module.exports = __webpack_public_path__ + "img/98.7.00756c35.png";